import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { AuctionSearch } from './pages/AuctionSearch';
import { BrowseByState } from './pages/BrowseByState';
import { Contact } from './pages/Contact';
import { FindAuctioneer } from './pages/FindAuctioneer';
import { AdminProvider } from './contexts/AdminContext';
import { AuctioneerProvider } from './contexts/AuctioneerContext';
import { AdminLogin } from './pages/admin/AdminLogin';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { AdminAuctions } from './pages/admin/AdminAuctions';
import { AdminEmail } from './pages/admin/AdminEmail';
import { AdminDeletion } from './pages/admin/AdminDeletion';
import { AdminSync } from './pages/admin/AdminSync';
import { AdminIndividualAuctioneers } from './pages/admin/AdminIndividualAuctioneers';
import { AdminListingRequests } from './pages/admin/AdminListingRequests';
import { AdminClaimRequests } from './pages/admin/AdminClaimRequests';
import { AuctioneerLogin } from './pages/auctioneer/AuctioneerLogin';
import { AuctioneerDashboard } from './pages/auctioneer/AuctioneerDashboard';
import { IndividualAuctioneerClaim } from './pages/IndividualAuctioneerClaim';
import { IndividualAuctioneerLogin } from './pages/IndividualAuctioneerLogin';
import { IndividualAuctioneerDashboard } from './pages/IndividualAuctioneerDashboard';
import { AuctioneerRequestListing } from './pages/AuctioneerRequestListing';
import { TermsOfService } from './pages/TermsOfService';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { FindAuctioneerHub } from './pages/directory/FindAuctioneerHub';
import { StateAuctioneers } from './pages/directory/StateAuctioneers';
import { CityAuctioneers } from './pages/directory/CityAuctioneers';
import { AuctioneerProfile } from './pages/directory/AuctioneerProfile';
import { ForAuctioneers } from './pages/ForAuctioneers';
import { NearMeMap } from './pages/NearMeMap';
import '@/App.css';

function App() {
  return (
    <AdminProvider>
      <AuctioneerProvider>
        <div className="App min-h-screen flex flex-col">
          <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route
              path="/"
              element={
                <>
                  <Navbar />
                  <main className="flex-grow">
                    <AuctionSearch />
                  </main>
                  <Footer />
                </>
              }
            />
            <Route
              path="/search"
              element={
                <>
                  <Navbar />
                  <main className="flex-grow">
                    <AuctionSearch />
                  </main>
                  <Footer />
                </>
              }
            />
            <Route
              path="/browse"
              element={
                <>
                  <Navbar />
                  <main className="flex-grow">
                    <BrowseByState />
                  </main>
                  <Footer />
                </>
              }
            />
            <Route
              path="/contact"
              element={
                <>
                  <Navbar />
                  <main className="flex-grow">
                    <Contact />
                  </main>
                  <Footer />
                </>
              }
            />
            <Route
              path="/find-auctioneer"
              element={<FindAuctioneer />}
            />

            {/* SEO Directory Landing Pages */}
            <Route path="/find-an-auctioneer" element={<FindAuctioneerHub />} />
            <Route path="/near-me" element={<NearMeMap />} />
            <Route path="/find-an-auctioneer/:state" element={<StateAuctioneers />} />
            <Route path="/find-an-auctioneer/:state/:city" element={<CityAuctioneers />} />
            <Route path="/auctioneer/:slug" element={<AuctioneerProfile />} />
            <Route path="/for-auctioneers" element={<ForAuctioneers />} />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/auctions" element={<AdminAuctions />} />
            <Route path="/admin/individual-auctioneers" element={<AdminIndividualAuctioneers />} />
            <Route path="/admin/claim-requests" element={<AdminClaimRequests />} />
            <Route path="/admin/listing-requests" element={<AdminListingRequests />} />
            <Route path="/admin/email" element={<AdminEmail />} />
            <Route path="/admin/deletion" element={<AdminDeletion />} />
            <Route path="/admin/sync" element={<AdminSync />} />

            {/* Auctioneer Routes (Company) */}
            <Route path="/auctioneer/login" element={<AuctioneerLogin />} />
            <Route path="/auctioneer/dashboard" element={<AuctioneerDashboard />} />

            {/* Individual Auctioneer Routes */}
            <Route path="/auctioneer/individual/claim" element={<IndividualAuctioneerClaim />} />
            <Route path="/auctioneer/individual/login" element={<IndividualAuctioneerLogin />} />
            <Route path="/auctioneer/individual/dashboard" element={<IndividualAuctioneerDashboard />} />
            <Route path="/auctioneer/request-listing" element={<AuctioneerRequestListing />} />

            {/* Legal Pages */}
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
        </BrowserRouter>
      </div>
    </AuctioneerProvider>
    </AdminProvider>
  );
}

export default App;
